import React from 'react';

interface BenefitItem {
  title: string;
  description?: string;
  iconPath?: string;
}

interface BenefitsProps {
  title: string;
  subtitle: string;
  benefits: BenefitItem[];
}

const Benefits: React.FC<BenefitsProps> = ({
  title,
  subtitle,
  benefits
}) => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">{title}</h2>
          <p className="text-gray-600">{subtitle}</p>
        </div>
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="p-6 flex flex-col items-center text-center">
                {benefit.iconPath && (
                  <div className="w-24 h-24 mb-6 flex-shrink-0 flex items-center justify-center">
                    <img
                      src={benefit.iconPath}
                      alt={benefit.title}
                      className="w-24 h-24 object-contain"
                    />
                  </div>
                )}
                <h3 className="text-xl font-semibold mb-3">{benefit.title}</h3>
                {benefit.description && (
                  <p className="text-gray-600">{benefit.description}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;